import type { RouteRecordRaw } from 'vue-router';
import { CompanyAdminRoutes } from '@/types/enums/RouteNameEnums';
import { FeatureKeyEnum } from '@/types/enums/FeatureKeyEnum';
import { NavigationKeyEnum } from '@/types/enums/NavigationKeyEnum';

export const companyAdminRoutes: RouteRecordRaw[] = [
    {
        name: CompanyAdminRoutes.Locations,
        path: '/locations',
        component: () => import('@/apps/company-admin/locations/LocationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'locations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLocations,
            featureKey: FeatureKeyEnum.Locations,
        },
    },
    {
        name: CompanyAdminRoutes.LocationsCreate,
        path: '/locations/create',
        component: () => import('@/apps/company-admin/locations/LocationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'locations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLocations,
            featureKey: FeatureKeyEnum.Locations,
        },
    },
    {
        name: CompanyAdminRoutes.LocationsEdit,
        path: '/locations/:id',
        component: () => import('@/apps/company-admin/locations/LocationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'locations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLocations,
            featureKey: FeatureKeyEnum.Locations,
        },
    },
    {
        name: CompanyAdminRoutes.LocationsHooks,
        path: '/locations/:id/hooks',
        component: () => import('@/apps/company-admin/locations/LocationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'locations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLocations,
            featureKey: FeatureKeyEnum.Locations,
        },
    },
    {
        name: CompanyAdminRoutes.LocationsFloorPlan,
        path: '/locations/:id/floor-plan',
        component: () => import('@/apps/company-admin/locations/LocationFloorPlanPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'locationsFloorPlan',
            navigationKey: NavigationKeyEnum.CompanyAdminLocations,
            featureKey: FeatureKeyEnum.Locations,
        },
    },
    {
        name: CompanyAdminRoutes.CompanyApiTokens,
        path: '/tokens',
        component: () => import('@/apps/company-admin/pages/company-api-tokens/CompanyApiTokensPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companyApiTokens',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminApiTokens,
            featureKey: FeatureKeyEnum.ApiTokens,
        },
    },
    {
        name: CompanyAdminRoutes.CompanyApiTokensCreate,
        path: '/tokens/create',
        component: () => import('@/apps/company-admin/pages/company-api-tokens/CompanyApiTokensPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companyApiTokens',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminApiTokens,
            featureKey: FeatureKeyEnum.ApiTokens,
        },
    },
    {
        name: CompanyAdminRoutes.CompanyApiTokensEdit,
        path: '/tokens/:id',
        component: () => import('@/apps/company-admin/pages/company-api-tokens/CompanyApiTokensPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companyApiTokens',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminApiTokens,
            featureKey: FeatureKeyEnum.ApiTokens,
        },
    },
    {
        name: CompanyAdminRoutes.Products,
        path: '/products',
        component: () => import('@/apps/company-admin/pages/products/ProductsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'itemsAndAssets',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProducts,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsCreate,
        path: '/products/create',
        component: () => import('@/apps/company-admin/pages/products/ProductsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'itemsAndAssets',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProducts,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsEdit,
        path: '/products/:id',
        component: () => import('@/apps/company-admin/pages/products/ProductsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'itemsAndAssets',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProducts,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsEpc,
        path: '/products/:id/epc',
        component: () => import('@/apps/company-admin/pages/products/ProductsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'itemsAndAssets',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProducts,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsEanRegistration,
        path: '/products/ean-registration',
        component: () => import('@/apps/company-admin/pages/products/ProductEanRegistration.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'eanRegistration',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductEanRegistration,
            featureKey: FeatureKeyEnum.ProductEpcRegistration,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsEanRegistration2,
        path: '/products/ean-registration-2',
        component: () => import('@/apps/company-admin/pages/products/ProductEanRegistrationV2.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'eanRegistration',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductEanRegistration2,
            featureKey: FeatureKeyEnum.EanRegistrationChicdeal,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsBulkMarkingRegistration,
        path: '/products/bulk-marking',
        component: () => import('@/apps/company-admin/pages/products/ProductBulkMarkingRegistration.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'bulkMarkingRegistration',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductBulkMarkingRegistration,
            featureKey: FeatureKeyEnum.ProductEpcRegistration,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsStockIn,
        path: '/products/stock-in',
        component: () => import('@/apps/company-admin/pages/products/ProductStockIn.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'stockIn',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductStockIn,
            featureKey: FeatureKeyEnum.StockIn,
        },
    },
    {
        name: CompanyAdminRoutes.ProductsStockOut,
        path: '/products/stock-out',
        component: () => import('@/apps/company-admin/pages/products/ProductStockOut.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'stockOut',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductStockOut,
            featureKey: FeatureKeyEnum.StockOut,
        },
    },
    {
        name: CompanyAdminRoutes.Packages,
        path: '/packages',
        component: () => import('@/apps/company-admin/pages/packages/PackagesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'packages',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPackages,
            featureKey: FeatureKeyEnum.Packages,
        },
    },
    {
        name: CompanyAdminRoutes.PackageDetail,
        path: '/packages/:productId',
        component: () => import('@/apps/company-admin/pages/packages/PackageDetail.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'packageDetail',
            navigationKey: NavigationKeyEnum.CompanyAdminPackageDetail,
            featureKey: FeatureKeyEnum.Packages,
        },
    },
    {
        name: CompanyAdminRoutes.AntennaStatus,
        path: '/antenna-status/:antennaUuid?',
        component: () => import('@/apps/company-admin/pages/antenna-status/AntennaStatusPage.vue'),
        meta: { requiresAuth: true, pageTitle: 'antennaStatus' },
    },
    {
        name: CompanyAdminRoutes.Promotions,
        path: '/promotions',
        component: () => import('@/apps/company-admin/pages/promotions/PromotionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'promotions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPromotions,
            featureKey: FeatureKeyEnum.Promotions,
        },
    },
    {
        name: CompanyAdminRoutes.PromotionsCreate,
        path: '/promotions/create',
        component: () => import('@/apps/company-admin/pages/promotions/PromotionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'promotions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPromotions,
            featureKey: FeatureKeyEnum.Promotions,
        },
    },
    {
        name: CompanyAdminRoutes.PromotionsEdit,
        path: '/promotions/:id',
        component: () => import('@/apps/company-admin/pages/promotions/PromotionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'promotions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPromotions,
            featureKey: FeatureKeyEnum.Promotions,
        },
    },
    {
        name: CompanyAdminRoutes.Operators,
        path: '/operators',
        component: () => import('@/apps/company-admin/pages/operators/OperatorsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'operators',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminOperators,
            featureKey: FeatureKeyEnum.Operators,
        },
    },
    {
        name: CompanyAdminRoutes.OperatorsCreate,
        path: '/operators/create',
        component: () => import('@/apps/company-admin/pages/operators/OperatorsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'operators',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminOperators,
            featureKey: FeatureKeyEnum.Operators,
        },
    },
    {
        name: CompanyAdminRoutes.OperatorsEdit,
        path: '/operators/:id',
        component: () => import('@/apps/company-admin/pages/operators/OperatorsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'operators',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminOperators,
            featureKey: FeatureKeyEnum.Operators,
        },
    },
    {
        name: CompanyAdminRoutes.OperatorAccessLogs,
        path: '/operator-access-logs',
        component: () => import('@/apps/company-admin/pages/operators/OperatorAccessLogsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'operatorAccessLogs',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminOperatorAccessLogs,
            featureKey: FeatureKeyEnum.Operators,
        },
    },
    {
        name: CompanyAdminRoutes.Transactions,
        path: '/transactions',
        component: () => import('@/apps/company-admin/pages/transactions/TransactionsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'transactions',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminTransactions,
            featureKey: FeatureKeyEnum.Transactions,
        },
    },
    {
        name: CompanyAdminRoutes.Receipts,
        path: '/receipts',
        component: () => import('@/apps/company-admin/pages/receipts/ReceiptsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'receipts',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminReceipts,
            featureKey: FeatureKeyEnum.Transactions,
        },
    },
    {
        name: CompanyAdminRoutes.Vouchers,
        path: '/vouchers',
        component: () => import('@/apps/company-admin/pages/vouchers/VouchersList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'vouchers',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminVouchers,
            featureKey: FeatureKeyEnum.Vouchers,
        },
    },
    {
        name: CompanyAdminRoutes.LiveStore,
        path: '/live-store',
        component: () => import('@/apps/company-admin/pages/live-store/LiveStorePage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'liveStore',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLiveStore,
            featureKey: FeatureKeyEnum.LiveStore,
        },
    },
    {
        name: CompanyAdminRoutes.LiveStoreView,
        path: '/live-store/:id(\\d+)',
        component: () => import('@/apps/company-admin/pages/live-store/LiveStorePage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'liveStore',
            navigationKey: NavigationKeyEnum.CompanyAdminLiveStore,
            featureKey: FeatureKeyEnum.LiveStore,
        },
    },
    {
        name: CompanyAdminRoutes.LiveWarehouse,
        path: '/live-warehouse',
        component: () => import('@/apps/company-admin/pages/live-warehouse/LiveWarehousePage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'liveWarehouse',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLiveWarehouse,
            featureKey: FeatureKeyEnum.LiveWarehouse,
        },
    },
    {
        name: CompanyAdminRoutes.LiveWarehouseView,
        path: '/live-warehouse/:id(\\d+)',
        component: () => import('@/apps/company-admin/pages/live-warehouse/LiveWarehousePage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'liveWarehouse',
            navigationKey: NavigationKeyEnum.CompanyAdminLiveWarehouse,
            featureKey: FeatureKeyEnum.LiveWarehouse,
        },
    },

    // Temporarily hidden — code kept (warehouse analysis)
    // {
    //     name: CompanyAdminRoutes.WarehouseAnalysis,
    //     path: '/warehouse-analysis',
    //     component: () => import('@/apps/company-admin/pages/warehouse-analysis/WarehouseAnalysisPage.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         pageTitle: 'warehouseAnalysis',
    //         canAddToFavorite: true,
    //         navigationKey: NavigationKeyEnum.CompanyAdminWarehouseAnalysis,
    //         featureKey: FeatureKeyEnum.WarehouseAnalysis,
    //     },
    // },
    // {
    //     name: CompanyAdminRoutes.WarehouseAnalysisView,
    //     path: '/warehouse-analysis/:id(\\d+)',
    //     component: () => import('@/apps/company-admin/pages/warehouse-analysis/WarehouseAnalysisPage.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         pageTitle: 'warehouseAnalysis',
    //         navigationKey: NavigationKeyEnum.CompanyAdminWarehouseAnalysis,
    //         featureKey: FeatureKeyEnum.WarehouseAnalysis,
    //     },
    // },
    {
        name: CompanyAdminRoutes.StoreAnalysis,
        path: '/store-analysis',
        component: () => import('@/apps/company-admin/pages/store-analysis/StoreAnalysisPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'storeAnalysis',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminStoreAnalysis,
            featureKey: FeatureKeyEnum.StoreAnalysis,
        },
    },
    {
        name: CompanyAdminRoutes.StoreAnalysisView,
        path: '/store-analysis/:id(\\d+)',
        component: () => import('@/apps/company-admin/pages/store-analysis/StoreAnalysisPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'storeAnalysis',
            navigationKey: NavigationKeyEnum.CompanyAdminStoreAnalysis,
            featureKey: FeatureKeyEnum.StoreAnalysis,
        },
    },
    {
        name: CompanyAdminRoutes.SalesOverview,
        path: '/sales-overview',
        component: () => import('@/apps/company-admin/pages/sales-overview/SalesOverviewView.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'salesOverview',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminSalesOverview,
            featureKey: FeatureKeyEnum.SalesOverview,
        },
    },
    {
        name: CompanyAdminRoutes.TaggingAttendance,
        path: '/tagging-attendance',
        component: () => import('@/apps/company-admin/pages/tagging-attendance/TaggingAttendanceList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'taggingAttendance',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminTaggingAttendance,
            featureKey: FeatureKeyEnum.TaggingAttendance,
        },
    },
    {
        name: CompanyAdminRoutes.TruckReport,
        path: '/truck-report',
        component: () => import('@/apps/company-admin/pages/truck-report/TruckReportList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'truckReport',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminTruckReport,
            featureKey: FeatureKeyEnum.TruckReport,
        },
    },
    {
        // The truck number is free text that may hold slashes, so it travels in the query.
        name: CompanyAdminRoutes.TruckReportDetail,
        path: '/truck-report/detail',
        component: () => import('@/apps/company-admin/pages/truck-report/TruckReportDetail.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'truckReportDetail',
            navigationKey: NavigationKeyEnum.CompanyAdminTruckReportDetail,
            featureKey: FeatureKeyEnum.TruckReport,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionContainers,
        path: '/waste-collection/containers',
        component: () => import('@/apps/company-admin/pages/waste-collection/ContainersList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionContainers',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionContainers,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionContainersCreate,
        path: '/waste-collection/containers/create',
        component: () => import('@/apps/company-admin/pages/waste-collection/ContainersList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionContainers',
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionContainers,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        // Deliberately not "<base>Detail": useFormDialog would treat it as the register dialog's route.
        name: CompanyAdminRoutes.WasteCollectionContainerDetail,
        path: '/waste-collection/containers/:epcId',
        component: () => import('@/apps/company-admin/pages/waste-collection/ContainersList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionContainers',
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionContainers,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionMap,
        path: '/waste-collection/map',
        component: () => import('@/apps/company-admin/pages/waste-collection/WasteMapPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionMap',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionMap,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionRuns,
        path: '/waste-collection/runs',
        component: () => import('@/apps/company-admin/pages/waste-collection/CollectionRunsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionRuns',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionRuns,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionRunDetail,
        path: '/waste-collection/runs/:deviceUuid',
        component: () => import('@/apps/company-admin/pages/waste-collection/CollectionRunDetail.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionRunDetail',
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionRuns,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        // A print sheet without the app layout, opened in its own tab from the run detail.
        name: CompanyAdminRoutes.WasteCollectionRunPrint,
        path: '/waste-collection/runs/:deviceUuid/print',
        component: () => import('@/apps/company-admin/pages/waste-collection/CollectionRunPrint.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionRunPrint',
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionRuns,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionEvents,
        path: '/waste-collection/events',
        component: () => import('@/apps/company-admin/pages/waste-collection/CollectionEventsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionEvents',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionEvents,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionVehicles,
        path: '/waste-collection/vehicles',
        component: () => import('@/apps/company-admin/pages/waste-collection/VehiclesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionVehicles',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionVehicles,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionContainerTypes,
        path: '/waste-collection/container-types',
        component: () => import('@/apps/company-admin/pages/waste-collection/ContainerTypesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionContainerTypes',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionContainerTypes,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.WasteCollectionContainerTypesCreate,
        path: '/waste-collection/container-types/create',
        component: () => import('@/apps/company-admin/pages/waste-collection/ContainerTypesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'wasteCollectionContainerTypes',
            navigationKey: NavigationKeyEnum.CompanyAdminWasteCollectionContainerTypes,
            featureKey: FeatureKeyEnum.WasteCollection,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTests,
        path: '/sorting-tests/tests',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SortingTestsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTests',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTests,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestDetail,
        path: '/sorting-tests/tests/:id(\\d+)',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SortingTestDetail.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestDetail',
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTests,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsSamples,
        path: '/sorting-tests/samples',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SamplesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsSamples',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsSamples,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsSamplesCreate,
        path: '/sorting-tests/samples/create',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SamplesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsSamples',
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsSamples,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsSamplesEdit,
        path: '/sorting-tests/samples/:id(\\d+)/edit',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SamplesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsSamples',
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsSamples,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        // Deliberately not "<base>Detail": useFormDialog would treat it as the sample dialog's route.
        name: CompanyAdminRoutes.SortingTestsSampleDetail,
        path: '/sorting-tests/samples/:id(\\d+)',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SampleDetail.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsSampleDetail',
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsSamples,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsStations,
        path: '/sorting-tests/stations',
        component: () => import('@/apps/company-admin/pages/sorting-tests/StationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsStations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsStations,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsStationsCreate,
        path: '/sorting-tests/stations/create',
        component: () => import('@/apps/company-admin/pages/sorting-tests/StationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsStations',
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsStations,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsStationsEdit,
        path: '/sorting-tests/stations/:id(\\d+)/edit',
        component: () => import('@/apps/company-admin/pages/sorting-tests/StationsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsStations',
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsStations,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.SortingTestsLine,
        path: '/sorting-tests/line',
        component: () => import('@/apps/company-admin/pages/sorting-tests/SortingLineEditor.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'sortingTestsLine',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminSortingTestsLine,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.LabelDesigns,
        path: '/printing/label-designs',
        component: () => import('@/apps/company-admin/pages/printing/LabelDesignsList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'labelDesigns',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminLabelDesigns,
            featureKey: FeatureKeyEnum.SortingTests,
        },
    },
    {
        name: CompanyAdminRoutes.Statistics,
        path: '/statistics',
        component: () => import('@/apps/company-admin/pages/statistics/StatisticsView.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'statistics',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminStatistics,
            featureKey: FeatureKeyEnum.Statistics,
        },
    },
    {
        name: CompanyAdminRoutes.Settings,
        path: '/company/settings',
        component: () => import('@/apps/company-admin/pages/settings/CompanySettingsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'companySettings',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminSettings,
            featureKey: FeatureKeyEnum.Settings,
        },
    },
    {
        name: CompanyAdminRoutes.TranslationsOverview,
        path: '/company/translations',
        component: () => import('@/apps/company-admin/pages/settings/TranslationsOverviewPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'translations.title',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminTranslations,
        },
    },
    {
        name: CompanyAdminRoutes.Warehouse,
        path: '/warehouse',
        component: () => import('@/apps/company-admin/pages/warehouse/WarehousePage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'warehouse',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWarehouse,
            featureKey: FeatureKeyEnum.Warehouse,
        },
    },
    {
        name: CompanyAdminRoutes.WarehouseFloorPlan,
        path: '/warehouse/:nodeId/floor-plan',
        component: () => import('@/apps/company-admin/pages/warehouse/WarehouseFloorPlanPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'warehouseFloorPlan',
            navigationKey: NavigationKeyEnum.CompanyAdminWarehouse,
            featureKey: FeatureKeyEnum.Warehouse,
        },
    },
    {
        name: CompanyAdminRoutes.InventoryRetail,
        path: '/inventory/retail',
        component: () => import('@/apps/company-admin/pages/inventory/InventoryPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'inventoryRetail',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminInventoryRetail,
            featureKey: FeatureKeyEnum.Inventory,
        },
    },
    {
        name: CompanyAdminRoutes.InventoryRetailDetail,
        path: '/inventory/retail/:id',
        component: () => import('@/apps/company-admin/pages/inventory/InventoryPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'inventoryRetail',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminInventoryRetail,
            featureKey: FeatureKeyEnum.Inventory,
        },
    },
    {
        name: CompanyAdminRoutes.InventoryLogistics,
        path: '/inventory/logistics',
        component: () => import('@/apps/company-admin/pages/inventory/InventoryPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'inventoryLogistics',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminInventoryLogistics,
            featureKey: FeatureKeyEnum.Inventory,
        },
    },
    {
        name: CompanyAdminRoutes.InventoryLogisticsDetail,
        path: '/inventory/logistics/:id',
        component: () => import('@/apps/company-admin/pages/inventory/InventoryPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'inventoryLogistics',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminInventoryLogistics,
            featureKey: FeatureKeyEnum.Inventory,
        },
    },
    {
        name: CompanyAdminRoutes.InventoryManufacturing,
        path: '/inventory/manufacturing',
        component: () => import('@/apps/company-admin/pages/inventory/InventoryPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'inventoryManufacturing',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminInventoryManufacturing,
            featureKey: FeatureKeyEnum.Inventory,
        },
    },
    {
        name: CompanyAdminRoutes.InventoryManufacturingDetail,
        path: '/inventory/manufacturing/:id',
        component: () => import('@/apps/company-admin/pages/inventory/InventoryPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'inventoryManufacturing',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminInventoryManufacturing,
            featureKey: FeatureKeyEnum.Inventory,
        },
    },
    {
        name: CompanyAdminRoutes.Devices,
        path: '/devices',
        component: () => import('@/apps/company-admin/pages/devices/DevicesPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'devices',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminDevices,
            featureKey: FeatureKeyEnum.Devices,
        },
    },
    {
        name: CompanyAdminRoutes.DevicesDetail,
        path: '/devices/:id',
        component: () => import('@/apps/company-admin/pages/devices/DevicesPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'devices',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminDevices,
            featureKey: FeatureKeyEnum.Devices,
        },
    },
    {
        name: CompanyAdminRoutes.DevicesEdit,
        path: '/devices/:id/edit',
        component: () => import('@/apps/company-admin/pages/devices/DevicesPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'devices',
            navigationKey: NavigationKeyEnum.CompanyAdminDevices,
            featureKey: FeatureKeyEnum.Devices,
        },
    },
    {
        name: CompanyAdminRoutes.PaymentConfigurations,
        path: '/payment-configurations',
        component: () => import('@/apps/company-admin/pages/payment-configurations/PaymentConfigurationsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'paymentConfigurations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPaymentConfigurations,
            featureKey: FeatureKeyEnum.PaymentConfigurations,
        },
    },
    {
        name: CompanyAdminRoutes.PaymentConfigurationsCreate,
        path: '/payment-configurations/create',
        component: () => import('@/apps/company-admin/pages/payment-configurations/PaymentConfigurationsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'paymentConfigurations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPaymentConfigurations,
            featureKey: FeatureKeyEnum.PaymentConfigurations,
        },
    },
    {
        name: CompanyAdminRoutes.PaymentConfigurationsEdit,
        path: '/payment-configurations/:id',
        component: () => import('@/apps/company-admin/pages/payment-configurations/PaymentConfigurationsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'paymentConfigurations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPaymentConfigurations,
            featureKey: FeatureKeyEnum.PaymentConfigurations,
        },
    },
    {
        name: CompanyAdminRoutes.ErosConfigurations,
        path: '/eros-configurations',
        component: () => import('@/apps/company-admin/pages/eros-configurations/ErosConfigurationsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'erosConfigurations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminErosConfigurations,
            featureKey: FeatureKeyEnum.ErosConfigurations,
        },
    },
    {
        name: CompanyAdminRoutes.ErosConfigurationsCreate,
        path: '/eros-configurations/create',
        component: () => import('@/apps/company-admin/pages/eros-configurations/ErosConfigurationsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'erosConfigurations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminErosConfigurations,
            featureKey: FeatureKeyEnum.ErosConfigurations,
        },
    },
    {
        name: CompanyAdminRoutes.ErosConfigurationsEdit,
        path: '/eros-configurations/:id',
        component: () => import('@/apps/company-admin/pages/eros-configurations/ErosConfigurationsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'erosConfigurations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminErosConfigurations,
            featureKey: FeatureKeyEnum.ErosConfigurations,
        },
    },
    {
        name: CompanyAdminRoutes.PriceTemplates,
        path: '/price-templates',
        component: () => import('@/apps/company-admin/pages/price-templates/PriceTemplatesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'priceTemplates.title',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPriceTemplates,
            featureKey: FeatureKeyEnum.PriceTemplates,
        },
    },
    {
        name: CompanyAdminRoutes.PriceTemplatesCreate,
        path: '/price-templates/create',
        component: () => import('@/apps/company-admin/pages/price-templates/PriceTemplatesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'priceTemplates.title',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPriceTemplates,
            featureKey: FeatureKeyEnum.PriceTemplates,
        },
    },
    {
        name: CompanyAdminRoutes.PriceTemplatesEdit,
        path: '/price-templates/:id',
        component: () => import('@/apps/company-admin/pages/price-templates/PriceTemplatesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'priceTemplates.title',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminPriceTemplates,
            featureKey: FeatureKeyEnum.PriceTemplates,
        },
    },
    {
        name: CompanyAdminRoutes.AiChat,
        path: '/ai-chat',
        component: () => import('@/apps/company-admin/pages/ai-chat/AiChatPage.vue'),
        meta: {
            requiresAuth: true,
            canAddToFavorite: false,
            navigationKey: NavigationKeyEnum.CompanyAdminAiChat,
            featureKey: FeatureKeyEnum.AiChat,
            pageTitle: 'aiChat',
            hidePageTitle: true,
            skipFeatureCheck: true,
        },
    },
    {
        name: CompanyAdminRoutes.AiChatDetail,
        path: '/ai-chat/:id',
        component: () => import('@/apps/company-admin/pages/ai-chat/AiChatPage.vue'),
        meta: {
            requiresAuth: true,
            canAddToFavorite: false,
            navigationKey: NavigationKeyEnum.CompanyAdminAiChat,
            featureKey: FeatureKeyEnum.AiChat,
            pageTitle: 'aiChat',
            hidePageTitle: true,
            skipFeatureCheck: true,
        },
    },
    {
        name: CompanyAdminRoutes.Insights,
        path: '/insights',
        component: () => import('@/apps/company-admin/pages/insights/InsightsPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'insights',
            canAddToFavorite: true,
            featureKey: FeatureKeyEnum.Insights,
            navigationKey: NavigationKeyEnum.CompanyAdminInsights,
        },
    },
    {
        name: CompanyAdminRoutes.RoiCalculator,
        path: '/roi-calculator',
        component: () => import('@/apps/company-admin/pages/roi-calculator/RoiCalculatorPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'roiCalculator',
            canAddToFavorite: true,
            featureKey: FeatureKeyEnum.RoiCalculator,
            navigationKey: NavigationKeyEnum.CompanyAdminRoiCalculator,
        },
    },
    {
        name: CompanyAdminRoutes.PisnerRoi,
        path: '/roi',
        component: () => import('@/apps/company-admin/pages/pisner-roi/PisnerRoiPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'roiCalculator',
            canAddToFavorite: true,
            featureKey: FeatureKeyEnum.PisnerRoi,
            navigationKey: NavigationKeyEnum.CompanyAdminPisnerRoi,
        },
    },
    {
        name: CompanyAdminRoutes.RfidBuilder,
        path: '/rfid-builder',
        component: () => import('@/apps/company-admin/pages/rfid-builder/RfidBuilderPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'rfidBuilder',
            canAddToFavorite: false,
            navigationKey: NavigationKeyEnum.CompanyAdminRfidBuilder,
        },
    },
    {
        name: CompanyAdminRoutes.PackingStationsMonitor,
        path: '/packing-stations/monitor',
        component: () => import('@/apps/company-admin/packing-stations/PackingStationMonitor.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'packingStations',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.PackingStationsMonitor,
            featureKey: FeatureKeyEnum.PackingStations,
        },
    },
    {
        name: CompanyAdminRoutes.ProductTypes,
        path: '/product-types',
        component: () => import('@/apps/company-admin/pages/product-types/ProductTypesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'products.productTypes',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductTypes,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.ProductTypesCreate,
        path: '/product-types/create',
        component: () => import('@/apps/company-admin/pages/product-types/ProductTypesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'products.productTypes',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductTypes,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.ProductTypesEdit,
        path: '/product-types/:id',
        component: () => import('@/apps/company-admin/pages/product-types/ProductTypesList.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'products.productTypes',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminProductTypes,
            featureKey: FeatureKeyEnum.Products,
        },
    },
    {
        name: CompanyAdminRoutes.Workers,
        path: '/workers',
        component: () => import('@/apps/company-admin/pages/workers/WorkersPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'workers',
            canAddToFavorite: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWorkers,
            featureKey: FeatureKeyEnum.Workers,
        },
    },
    {
        name: CompanyAdminRoutes.WorkerDetail,
        path: '/workers/:id',
        component: () => import('@/apps/company-admin/pages/workers/WorkerDetailPage.vue'),
        meta: {
            requiresAuth: true,
            pageTitle: 'workers',
            hidePageTitle: true,
            navigationKey: NavigationKeyEnum.CompanyAdminWorkers,
            featureKey: FeatureKeyEnum.Workers,
        },
    },
];
